import { useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { scrollRefToTop, type ScrollableRef } from '../utils/scrollRefToTop';

/**
 * useScrollResetOnFocus — scroll the given ref back to the top whenever the
 * screen regains focus.
 *
 * Why not react-navigation's `useScrollToTop`: that hook only reacts to a
 * parent tab/drawer `tabPress`, and this app is a pure native-stack (no tab or
 * drawer navigator), so it would never fire. `useFocusEffect` fires on every
 * focus — exactly what's needed when navigating back to a screen the
 * native-stack keeps mounted (its inner ScrollView keeps the old offset).
 */
export function useScrollResetOnFocus(ref: ScrollableRef): void {
  useFocusEffect(
    useCallback(() => {
      scrollRefToTop(ref);
    }, [ref]),
  );
}
